/* unplugin-vue-components disabled */import script from "./footerView.vue?vue&type=script&setup=true&lang=js"
export * from "./footerView.vue?vue&type=script&setup=true&lang=js"

import "./footerView.vue?vue&type=style&index=0&id=0331eca5&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0331eca5"]])

export default __exports__